import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '@core/config/api.config';
import { AuthSessionService } from '@core/auth/auth-session.service';
import { PUBLIC_CATALOG_REQUEST } from '@core/http/public-catalog-http.context';

function isApiRequest(url: string, apiBaseUrl: string): boolean {
  const base = (apiBaseUrl || '').replace(/\/$/, '');
  if (base) {
    return url.startsWith(base) || url.startsWith(`${base}/`);
  }
  // Same-origin: solo rutas /api/
  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return parsed.pathname.startsWith('/api/');
  } catch {
    return url.includes('/api/');
  }
}

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = inject(API_BASE_URL, { optional: true }) ?? '';
  if (!isApiRequest(req.url, apiBaseUrl)) {
    return next(req);
  }

  // Evitar adjuntar Bearer al endpoint de refresh (usa refresh_token en body).
  if (req.url.includes('/api/v1/auth/refresh')) {
    return next(req);
  }

  // Requests del storefront público (menú, checkout, servicios): nunca llevan Bearer,
  // incluso si hay un token (posiblemente viejo/expirado) de otra sesión en localStorage.
  if (req.context.get(PUBLIC_CATALOG_REQUEST)) {
    return next(req);
  }

  const token = inject(AuthSessionService).token();
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  );
};
